import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const pinBannerLogo = () => {

	const logo = document.querySelector('.banner__logo')

	if (!logo) return

	gsap.to(logo, {
		scrollTrigger: {
			pin: logo,
			trigger: '.banner',
			start: 'top top',
			end: 'bottom 75%'
		}
	})
}

export default () => {}